import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";
import { images } from "../assets";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        icon: "tools_zones",
        text: styledHeaderText(t("availabilityArea.availabilityArea", { ns: "dialogs" })),
      },
      applyText: t("actions.build", { ns: "common" }),
      help: {
        openAtFirst: false,
        hintsBlock: {
          title: t("availabilityArea.hintBlockTitle", { ns: "dialogs" }),
          hints: [
            {
              label: t("availabilityArea.sourceObject", { ns: "dialogs" }),
              img: images.initialObject,
            },
            {
              icon: "plus",
            },
            {
              label: t("availabilityArea.setTimeToArrive", { ns: "dialogs" }),
              img: images.timeDistanceToObject,
            },
            {
              icon: "pause",
            },
            {
              label: t("availabilityArea.timeLimitedArea", { ns: "dialogs" }),
              img: images.result,
            },
          ],
        },
      },
    }),
    [t],
  );
};
